import script from "./WallIntegrationsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./WallIntegrationsOverview.vue?vue&type=script&setup=true&lang=js"

import "./WallIntegrationsOverview.vue?vue&type=style&index=0&id=0ba91d39&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba91d39"]])

export default __exports__